import { useState } from "react";
import * as S from "./MktLandingPageSeniorsOrganism.style";
import {
  ArrowBackLine,
  ArrowForwardLine,
  grayScale,
} from "@teamsparta/design-system";
import { mktLandingPageSeniorsMentData } from "src/models/landing/seniors/seniors";
import MktLandingPageSeniorMentCard from "@/components/molecules/LandingPageMolecules/MktLandingPageSeniorMentCard/MktLandingPageSeniorMentCard";

export default function MktLandingPageSeniorsOrganism() {
  const [slideIndex, setSlideIndex] = useState({
    senior: 0,
  });

  const showSlides = (
    n: number,
    carouselData: {}[],
    cardsPerSlide: number,
    carouselType: "mentor" | "review" | "senior" | "senior"
  ) => {
    setSlideIndex((prev) => ({
      ...prev,
      [carouselType]:
        slideIndex[carouselType] + n >= carouselData.length - cardsPerSlide
          ? carouselData.length - cardsPerSlide
          : slideIndex[carouselType] + n <= 0
          ? 0
          : slideIndex[carouselType] + n,
    }));
  };
  return (
    <S.Wrapper>
      <S.Title>
        <>
          현직 마케터들이 인정한
          <br />
          실무 맞춤형 커리큘럼입니다.
        </>
      </S.Title>
      <MktLandingPageSeniorMentCard slideIndex={slideIndex.senior} />
      <S.Nav>
        <S.NavArrow>
          <S.PrevButton
            onClick={() =>
              showSlides(-3, mktLandingPageSeniorsMentData, 3, "senior")
            }
            disabled={slideIndex.senior === 0}
          >
            <ArrowBackLine
              color={
                slideIndex.senior === 0
                  ? `${grayScale.gray80}`
                  : `${grayScale.white}`
              }
              size={24}
            />
          </S.PrevButton>
          <S.NextButton
            onClick={() =>
              showSlides(3, mktLandingPageSeniorsMentData, 3, "senior")
            }
            disabled={
              slideIndex.senior >= mktLandingPageSeniorsMentData.length - 3
            }
          >
            <ArrowForwardLine
              color={
                slideIndex.senior >= mktLandingPageSeniorsMentData.length - 3
                  ? `${grayScale.gray80}`
                  : `${grayScale.white}`
              }
              size={24}
            />
          </S.NextButton>
        </S.NavArrow>
      </S.Nav>
    </S.Wrapper>
  );
}
